export default __webpack_public_path__ + "static/media/blue-cart.eaf6e755.svg";